export const breakpoints = {
  tablet: "screen and (max-width: 960px)",
  smallLaptop: "screen and (max-width: 1300px)",
  lg: "screen (max-width: 1530px)",
  xl: "screen and (min-width: 1531px)",
};
